const inviteBusiness = resolve => require.ensure([], () => resolve(require('@/views/inviteBusiness/inviteBusiness.vue')), 'inviteBusiness')
export default [
    {
        path: '/inviteBusiness',
        component: inviteBusiness,
        name: 'inviteBusiness',
        children: [
        ]
    }
]